import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="w-full py-16 md:py-20 relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20golden%20abstract%20background%20with%20soft%20light%20particles%2C%20elegant%20gradient%20from%20deep%20red%20to%20dark%2C%20luxurious%20atmosphere%2C%20clean%20cinematic%20composition%2C%20no%20text%2C%20premium%20vibe&width=1800&height=600&seq=cta-bg-join&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 to-foreground-950/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-bold font-heading text-background-50 mb-4">
          准备好开始您的精彩之旅了吗？
        </h2>
        <p className="text-background-300 text-sm md:text-base mb-8 max-w-lg mx-auto leading-relaxed">
          立即注册九游娱乐，领取新人大礼包，海量精品游戏等你来体验！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/categories"
            className="px-8 py-3.5 bg-accent-500 text-foreground-950 font-semibold rounded-lg hover:bg-accent-400 transition-all duration-200 text-base whitespace-nowrap w-full sm:w-auto"
          >
            立即注册
            <i className="ri-user-add-line ml-2"></i>
          </Link>
          <Link
            to="/about#contact"
            className="px-8 py-3.5 bg-background-50/10 text-background-50 font-medium rounded-lg hover:bg-background-50/20 border border-background-50/20 transition-all duration-200 text-base whitespace-nowrap w-full sm:w-auto"
          >
            联系客服
          </Link>
        </div>
      </div>
    </section>
  );
}